/**
 * @class Oskari.layeranalytics.StatusBundle
 *
 * Definition for bundle. See source for details.
 */
Oskari.clazz.define('Oskari.layeranalytics.StatusBundle', function () {}, {
  create: function create() {
    return Oskari.clazz.create('Oskari.layeranalytics.StatusBundleInstance');
  },
  update: function update(manager, bundle, bi, info) {}
}, {
  protocol: ['Oskari.bundle.Bundle'],
  source: {
    scripts: [{
      type: 'text/javascript',
      src: './instance.js'
    }]
  }
});
Oskari.bundle_manager.installBundleClass('layeranalytics', 'Oskari.layeranalytics.StatusBundle');
import './instance.js'